export const isSetsAreEqual = (set1: Set<unknown>, set2: Set<unknown>): boolean => {
    if (set1.size !== set2.size) {
        return false;
    }

    return Array.from(set1).every(element => {
        return set2.has(element);
    });
};
